const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export const format = (value: number) => formatter.format(value);

export const formatRate = (rate: number, forceKb = false) =>
  rate >= 1000 || forceKb
    ? `${format(rate / 1024)} KB/second`
    : `${format(rate)} B/second`;

export const formatSize = (size: number) =>
  size >= 1000 ? `${format(size / 1024)} KB` : `${format(size)} B`;
